import React, { memo } from 'react';

import { convertDigitToProperFormat } from 'utils/number';
import { NumberOrNull } from 'store/entity/types';

import messages from './Messages';
import Icon from '../../../../../Icon';
import { green } from '../../../../../../utils/style/colors';

interface IComponentProps {
  choices: Array<{ text: string; value: string; score: NumberOrNull }>;
  children: React.ReactNode;
  hasScore: boolean;
  booleanValue?: boolean;
}

const MultiChoiceViewer: React.FC<IComponentProps> = ({
  children,
  choices,
  hasScore,
  booleanValue,
}) => {
  return (
    <span>
      <div className="">
        <div className="col s12">{children}</div>
      </div>
      <table style={{ width: '100%', maxWidth: '100%' }}>
        {choices.map((choice) => {
          return (
            <tr key={choice.value}>
              <td style={{ textAlign: 'start' }}>{choice.text}</td>
              {hasScore && (
                <td>
                  {booleanValue ? (
                    choice.score ? (
                      <span style={{ color: green }}>
                        <Icon type={'check'} color={green} />{' '}
                        {messages.correctAnswer}{' '}
                      </span>
                    ) : (
                      <span />
                    )
                  ) : // replace '==' with '==='
                  choice.score === null ? (
                    messages.noScore
                  ) : (
                    convertDigitToProperFormat(messages.getScore(choice.score))
                  )}
                </td>
              )}
            </tr>
          );
        })}
      </table>
    </span>
  );
};

export default memo(MultiChoiceViewer);
